<template>
  <div class="order_detail">
    <div class="order_detail_container">
      <el-button size="small" @click="handleBack" icon="el-icon-arrow-left" class="back">返回</el-button>
      <el-row class="mt2 step_container" type="flex" justify="center">
        <el-col :span="8">
          <el-steps :active="active" process-status="success" :align-center="true">
            <el-step :title="item" v-for="(item, index) in stepList" :key="index"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="flex-start">
        <el-col :span="19">
          <el-form ref="form" :inline="true" label-position="right" :model="form" label-width="120px">
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width:450px">
                订单信息
                <!-- <span @click="toCustomer" style="color:#409EFF" v-if="formName != 'customerDetail'"
                  class="toCustomer">客户详情</span> -->
              </div>
              <div class="title">{{ `APP盲订订单号:${form.AppBlindOrderId}` }}</div>

            </el-row>
            <el-row class="content-wrap">
              <el-form-item class="form_item" label="客户姓名：">
                {{ form.customerName }}
              </el-form-item>
              <el-form-item class="form_item" label="盲订车系：">
                {{ form.seriesName }}
              </el-form-item>
              <el-form-item class="form_item" label="订金：">
                {{ form.PaymentMoney ? `${form.PaymentMoney}元` : '' }}
              </el-form-item>
              <el-form-item class="form_item" label="联系方式：">
                {{ form.customerPhone }}
              </el-form-item>
              <el-form-item class="form_item" label="创建时间：">
                {{ form.createdTime }}
              </el-form-item>
              <el-form-item class="form_item" label="意向金：">
                {{ form.IntentionMoney ? `${form.IntentionMoney}元` : '' }}
              </el-form-item>
              <el-form-item class="form_item" label="退款状态：">
                {{ refundStatusMap.get(form.refundStatus) }}
              </el-form-item>
              <el-form-item class="form_item" label="退款时间：">
                {{ form.refundTime }}
              </el-form-item>
              <el-row>
                <el-form-item class="form_item" label="备注：">
                  {{ form.remark }}
                </el-form-item>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="5" style="margin-left:20px">
          <div class="title">订单操作记录</div>
          <el-row style="min-height:196px;background:#fff; max-height: 610px; overflow-y: auto;">
            <el-timeline style="margin-top:15px;margin-left:30px">
              <el-timeline-item v-for="(item, index) in timelines" :key="index" color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')">
                <div class="boxLine">
                  <div class="title">{{ blindOrderStatusMap.get(item.blindOrderStatus) }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { stepListMap } from "./constants.js"
import { parseTime, deepClone } from '@/assets/js/util';
import { refundStatusMap, blindOrderStatusMap } from './constants.js'
const orderStatusType = [0, 1, 2, 3, 4]

export default {
  components: {
  },
  data() {
    return {
      refundStatusMap,
      blindOrderStatusMap,
      parseTime,
      dealer: this.$common.getLoginInfo().profile,
      // formName: this.$route.query.from,
      active: 0,
      form: {}, // deepClone(initForm),
      timelines: [],
      stepList: [],
    };
  },
  watch: {
  },
  computed: {

  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    // formatLabel(val, list, { name = 'dataDisplay', value = 'dataValue' } = {}) {
    //   const row = list.find(item => item[value] === val) || {}
    //   return row[name] || ''
    // },
    // 返回
    handleBack() {
      if (this.$route.query.from === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId,
        });
      } else if (this.$route.query.from === "order") {
        this.$router.push({
          path: "/order/blindOrder",
        });
      } else {
        this.$router.go(-1);
      }
    },
    // 去客户详情
    // toCustomer() {
    //   this.$router.push({
    //     path: `/customer/detail/${this.form.customerId}`,
    //   });
    // },
    // 获取订单详情
    getOrderDetail() {
      this.$httpAuth
        .post("/v2/appCustomerService/blindOrderDetail", {
          blindOrderId: Number(this.$route.query.blingOrderId),
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          let data = res.data;
          const { blindOrder = {}, timelines = [] } = data || {}

          this.form = blindOrder
          this.timelines = timelines

          let row = { list: [], step: 0 }
          if (orderStatusType.includes(this.form.orderStatus)) {
            row = stepListMap.get(this.form.orderStatus)
          }
          this.stepList = row.list;
          this.active = row.step

        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
.order_detail {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}

.order_detail_container {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

.content-wrap {
  background: #fff;
  padding: 15px 0;
}

.content-wrap .el-form-item {
  width: 30%;
}

.step_container {
  background: #fff;
  padding: 35px 0 20px 0;
}

.back {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.boxLine {
  width: 250px;
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLine .title {
  font-weight: 600;
  color: #000;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}
</style>
